import { render } from "./preset-module.vue?vue&type=template&id=f8312f78&scoped=true&lang=pug"
import script from "./preset-module.vue?vue&type=script&lang=js"
export * from "./preset-module.vue?vue&type=script&lang=js"

import "./preset-module.vue?vue&type=style&index=0&id=f8312f78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8312f78"]])

export default __exports__